module.exports = __webpack_public_path__ + "img/One-Stop-Shop_web_WP20.63abf3f9.jpg";